import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeLinks: [],
  status: "idle",
  error: null,
};

export const activeLinksByCountryRoleSlice = createSlice({
  name: "activeLinks",
  initialState,
  reducers: {
    activeLinksRequested: (state) => {
      state.status = "loading";
    },
    activeLinksRequestFailed: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    activeLinksRequestSucceeded: (state, action) => {
      state.status = "succeeded";
      state.activeLinks = action.payload;
    },
  },
});

export const {
  activeLinksRequested,
  activeLinksRequestFailed,
  activeLinksRequestSucceeded,
} = activeLinksByCountryRoleSlice.actions;

export default activeLinksByCountryRoleSlice.reducer;
